import config from 'config';
const LOAD = 'vidiprinter/LOAD';
const LOAD_SUCCESS = 'vidiprinter/LOAD_SUCCESS';
const LOAD_FAIL = 'vidiprinter/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.vidiprinter
      && globalState.football.vidiprinter.loading;
}

export function load(limit) {
  const data = limit ? { params: { max_results: limit } } : {};

  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.football.vidiprinter, data)
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/vidiprinter.js